var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('de-layout-content',[_c('app-template-content',{attrs:{"show-position":'system-setting'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }